import { FC, useEffect, useState } from "react";
import AdminObservationSlide from "src/features/observationsAdmin/components/AdminObservationSlide/AdminObservationSlide";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { Button } from "src/components/ui/button";

interface Props {
	observations: number[];
	form?: Partial<IObservationForm>;
	showInstanceSummary?: boolean;
	handlecloseReportAnswerModalClick?: () => void;
	showGradingReportState?: boolean;
}

const ObservationFormsCarousel: FC<Props> = ({
	observations,
	showInstanceSummary = false,
	form,
	handlecloseReportAnswerModalClick,
	showGradingReportState
}) => {
	const [activeIndex, setActiveIndex] = useState(
		Math.max(0, observations.length - 1)
	);

	useEffect(() => {
		setActiveIndex((prev) =>
			Math.min(prev, Math.max(0, observations.length - 1))
		);
	}, [observations]);

	if (observations.length === 0) {
		return null;
	}

	const hasPrev = activeIndex > 0;
	const hasNext = activeIndex < observations.length - 1;

	return (
		<div className="w-full">
			{observations.length > 1 && (
				<div className="flex items-center justify-center gap-2 mb-4">
					<Button
						aria-label="Previous observation form"
						variant="ghost"
						size="icon"
						disabled={!hasPrev}
						onClick={() => setActiveIndex((i) => i - 1)}
					>
						<ArrowLeft size={20} />
					</Button>

					<span className="text-sm text-muted-foreground">
						{activeIndex + 1} of {observations.length}
					</span>

					<Button
						aria-label="Next observation form"
						variant="ghost"
						size="icon"
						disabled={!hasNext}
						onClick={() => setActiveIndex((i) => i + 1)}
					>
						<ArrowRight size={20} />
					</Button>
				</div>
			)}

			<AdminObservationSlide
				key={observations[activeIndex]}
				formInstanceId={observations[activeIndex]}
				showInstanceSummary={showInstanceSummary}
				form={form}
				handlecloseReportAnswerModalClick={handlecloseReportAnswerModalClick}
				showGradingReportState={showGradingReportState}
			/>
		</div>
	);
};

export default ObservationFormsCarousel;
